export const faqBlocks = {
    blocks: [
        {
            block: "mainBlock",
            mainHeader: "Личный кабинет WAY2WEI",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Интеллектуальное применение ресурса эмоций",
                },
                {
                    type: "text",
                    value:
                        "Платформа помогает компаниям повышать качество управленческих решений, опираясь на данные об эмоциональном состоянии сотрудников и команд. Решение позволяет снижать риски потери продуктивности, улучшать качество HR-процессов и предотвращать выгорание специалистов. Используя встроенные инструменты аналитики, развития навыков и диагностики, компании получают доступ к прогнозам, персональным траекториям развития сотрудников и оценке эмоциональной среды организации.",
                },
                {
                    type: "h3",
                    value: "Подзаголовок",
                },
                {
                    type: "text",
                    value:
                        "Используя встроенные инструменты аналитики, развития навыков и диагностики, компании получают доступ к прогнозам, персональным траекториям развития сотрудников и оценке эмоциональной среды организации.",
                },
                {
                    type: "list",
                    items: [
                        "Используя встроенные инструменты аналитики",
                        "Развития навыков и диагностики",
                        "Компании получают доступ к прогнозам",
                        "Персональным траекториям развития сотрудников",
                    ],
                },
                {
                    type: "caption",
                    value: "Второстепенный стиль для подписей",
                },
                {
                    type: "link",
                    text: "Стиль для ссылок внутри текста",
                },
            ],
        },
    ],
};